import { parseFiniteNumber } from '../../parse-finite-number.js';
import { MANUFACTURING_ORDER_CONSTRAINTS } from './constraints.js';
export const MANUFACTURING_QUANTITY_MESSAGE = `${MANUFACTURING_ORDER_CONSTRAINTS.quantity.label} must be a number greater than 0 and ${MANUFACTURING_ORDER_CONSTRAINTS.quantity.max.toLocaleString('en-US')} or less.`;
/**
 * Reads a quantity out of a form text input, or `undefined` when it does not name one.
 *
 * Numeric fields are held as strings in the form because react-hook-form coerces a cleared
 * number input to `0` — which would reach the server as a real, invalid quantity rather than as
 * the absence the operator intended.
 */
export function parseManufacturingQuantityText(value) {
    const parsed = parseFiniteNumber(value);
    if (parsed === undefined)
        return undefined;
    if (parsed <= 0 || parsed > MANUFACTURING_ORDER_CONSTRAINTS.quantity.max)
        return undefined;
    return parsed;
}
//# sourceMappingURL=quantity-text.js.map